module.exports = __webpack_public_path__ + "static/media/empty-codes.f45efd01.svg";